<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Дипломатический центр</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/dipcentr1.jpg" width="150" height="106" />
		</p>
		<p><b>Дипломатический центр</b> - это строение позволяет просмотреть список союзов в игре, подать заявку на вступление или управлять союзом. Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisDipcentre',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>